import { CurrencyWidgetContent } from './CurrencyWidgetContent';
import type { CurrencyWidgetProps } from './useCurrencyWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const CurrencyWidget = ({ status, data, handlers, hooks, isSingleBillChildAccount }: CurrencyWidgetProps) => {
  return (
    <WithStatusHandling
      skeletonHeight={1}
      status={status}
      errorMessage={status === 'error' ? data.message : undefined}
      retry={status === 'error' ? handlers.retry : undefined}
    >
      {status === 'loaded' && (
        <CurrencyWidgetContent
          data={data}
          handlers={handlers}
          hooks={hooks}
          isSingleBillChildAccount={isSingleBillChildAccount}
        />
      )}
    </WithStatusHandling>
  );
};
